import React from 'react';

import {
  Avatar,
  Box,
  Card,
  LinearProgress,
  Typography,
  useTheme,
} from '@mui/material';
import { grey } from '@mui/material/colors';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

import useProgressLoading from '../../../../hooks/useProgressLoading';

const progressTitles = [
  {
    label: 'Gathering details...',
    min: 0,
    max: 20,
  },
  {
    label: 'Preparing analysis...',
    min: 20,
    max: 40,
  },
  {
    label: 'Reviewing data...',
    min: 40,
    max: 50,
  },
  {
    label: 'Processing information...',
    min: 50,
    max: 60,
  },
  {
    label: 'Examining patterns...',
    min: 60,
    max: 70,
  },
  {
    label: 'Organizing insights...',
    min: 70,
    max: 80,
  },
  {
    label: 'Structuring analysis...',
    min: 80,
    max: 100,
  },
];

const AiAnalysisLoading = ({
  isLoading,
}: {
  isLoading: boolean;
}) => {
  const { progress, progressTitle } = useProgressLoading({
    isLoading,
    progressTitles,
    expectedTime: 30_000,
  });
  const theme = useTheme();

  return (
    <Card
      variant="outlined"
      sx={{
        margin: 0,
        padding: 6,
        backgroundColor: theme.palette.background.grey,
        flexGrow: 1,
      }}
    >
      <Box display="flex" flexDirection="column" gap={2} alignItems="center" height="100%" justifyContent="center">
        <Avatar
          sx={{
            backgroundColor: grey[200],
            color: grey[400],
          }}
        >
          <AutoAwesomeIcon color="ai" />
        </Avatar>
        <Box width="100%">
          <Typography textAlign="center" fontWeight="bold">{progressTitle}</Typography>
          <LinearProgress
            variant="determinate"
            value={progress}
            sx={{
              height: 10,
              borderRadius: 5,
              marginTop: 1,
              '.MuiLinearProgress-bar': {
                background: theme.palette.ai.gradient,
              },
              background: theme.palette.grey[200],
            }}
          />
        </Box>
      </Box>
    </Card>
  );
};

export default AiAnalysisLoading;
